var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.propertyId
        ? _c("property-default-tech-select", {
            attrs: { "property-id": _vm.propertyId },
            on: { click: _vm.handleRowClick }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex mt-3" },
        [
          _c("service-entity-selector", {
            staticClass: "mr-2",
            attrs: {
              "use-entities": "",
              label: _vm.generateMessage("tech_search.fields.nav_full_id")
            },
            on: {
              "clear-items": function($event) {
                _vm.navFullId = _vm.entityId ? [_vm.entityId] : []
              }
            },
            model: {
              value: _vm.navFullId,
              callback: function($$v) {
                _vm.navFullId = $$v
              },
              expression: "navFullId"
            }
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mx-2",
            attrs: {
              label: _vm.generateMessage("tech_search.fields.employee_id"),
              outlined: "",
              dense: "",
              clearable: ""
            },
            model: {
              value: _vm.id,
              callback: function($$v) {
                _vm.id = $$v
              },
              expression: "id"
            }
          }),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "mx-2 pb-2",
            attrs: {
              label: _vm.generateMessage("tech_search.fields.full_name"),
              outlined: "",
              dense: "",
              clearable: ""
            },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          }),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "mx-2",
            attrs: {
              label: _vm.generateMessage("tech_search.fields.role"),
              clearable: "",
              dense: "",
              outlined: "",
              multiple: "",
              "item-value": "id",
              "item-text": "shortname",
              items: _vm.roles
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function({ item }) {
                  return [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
                }
              }
            ]),
            model: {
              value: _vm.role,
              callback: function($$v) {
                _vm.role = $$v
              },
              expression: "role"
            }
          }),
          _vm._v(" "),
          _c("v-select", {
            staticClass: "mx-2",
            attrs: {
              label: _vm.generateMessage("tech_search.type"),
              clearable: "",
              multiple: "",
              outlined: "",
              dense: "",
              "item-value": "id",
              "item-text": "name",
              items: _vm.positions
            },
            model: {
              value: _vm.type,
              callback: function($$v) {
                _vm.type = $$v
              },
              expression: "type"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("v-checkbox", {
                staticClass: "ma-0 pa-0",
                attrs: {
                  dense: "",
                  "hide-details": "",
                  label: _vm.generateMessage("tech_search.fields.scheduled"),
                  value: true
                },
                model: {
                  value: _vm.scheduled,
                  callback: function($$v) {
                    _vm.scheduled = $$v
                  },
                  expression: "scheduled"
                }
              }),
              _vm._v(" "),
              _c("v-checkbox", {
                staticClass: "ma-0 pa-0",
                attrs: {
                  dense: "",
                  "hide-details": "",
                  label: _vm.generateMessage("tech_search.fields.notScheduled"),
                  value: false
                },
                model: {
                  value: _vm.scheduled,
                  callback: function($$v) {
                    _vm.scheduled = $$v
                  },
                  expression: "scheduled"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasTESTING
            ? _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function({ on }) {
                          return [
                            _c(
                              "div",
                              _vm._g({}, on),
                              [
                                _vm.property
                                  ? _c("v-switch", {
                                      staticClass: "mx-5",
                                      attrs: {
                                        disabled: !_vm.isMap,
                                        inset: "",
                                        label: _vm.generateMessage(
                                          "tech_search.cardView.switch.title"
                                        )
                                      },
                                      model: {
                                        value: _vm.mapView,
                                        callback: function($$v) {
                                          _vm.mapView = $$v
                                        },
                                        expression: "mapView"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3676145339
                  )
                },
                [
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          !_vm.isMap
                            ? _vm.generateMessage(
                                "tech_search.cardView.switch.error"
                              )
                            : _vm.mapView
                            ? _vm.generateMessage(
                                "tech_search.cardView.switch.list"
                              )
                            : _vm.generateMessage(
                                "tech_search.cardView.switch.map"
                              )
                        ) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.mapView | !_vm.hasTESTING
        ? _c("v-data-table", {
            staticClass: "elevation-1 secondarybackground striped-table",
            attrs: {
              dense: "",
              "hide-default-footer": "",
              "fixed-header": "",
              "no-data-text": _vm.generateMessage("tech_search.noItems"),
              "disable-sort": "",
              loading: _vm.loading,
              "items-per-page": _vm.pageSize,
              page: _vm.pageIndex,
              headers: _vm.hasTESTING ? _vm.headersAbs : _vm.headers,
              height: "350",
              items: _vm.filteredItems,
              "item-key": "num",
              "item-class": item => {
                if (item.absence_today && _vm.hasTESTING) {
                  return "warning--text"
                } else if (item.scheduled) {
                  return "success--text"
                }
                return
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.entity_nav_full_id",
                  fn: function({ item }) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            item.entity_nav_full_id
                              ? `${item.entity_nav_full_id.substring(
                                  item.entity_nav_full_id.length - 3
                                )} - ${item.entity_name}`
                              : item.entity_name
                          ) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "item.phone",
                  fn: function({ item }) {
                    return [
                      item.phone_type
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "50%" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on }) {
                                      return [
                                        _c("div", _vm._g({}, on), [
                                          _c(
                                            "span",
                                            { staticClass: "font-weight-bold" },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    "(" + item.phone_type + ")"
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                item.phone &&
                                                  item.phone.slice(0, 5) !==
                                                    "EMAIL"
                                                  ? item.phone
                                                  : item.email
                                              ) +
                                              "\n          "
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    item.other_means
                                      ? item.other_means
                                      : "Pas d'autre moyen"
                                  ) +
                                  "\n      "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "top",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-end" },
                        [
                          _c("custom-page-selector", {
                            staticClass: "pa-2",
                            attrs: {
                              totalItems: _vm.filteredItems.length,
                              "page-size": _vm.pageSize,
                              "page-index": _vm.pageIndex
                            },
                            on: {
                              "update:pageSize": function($event) {
                                _vm.pageSize = $event
                              },
                              "update:page-size": function($event) {
                                _vm.pageSize = $event
                              },
                              "update:pageIndex": function($event) {
                                _vm.pageIndex = $event
                              },
                              "update:page-index": function($event) {
                                _vm.pageIndex = $event
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "item.absence_today",
                  fn: function({ item }) {
                    return [
                      item.hours_of_absence
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "", "max-width": "50%" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function({ on }) {
                                      return [
                                        _c(
                                          "div",
                                          _vm._g({}, on),
                                          [
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  small: "",
                                                  "text-color": "opposite",
                                                  color: "warning"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(item.absence_today) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(item.hours_of_absence) +
                                    "\n        "
                                )
                              ])
                            ]
                          )
                        : _c(
                            "span",
                            [
                              item.absence_today
                                ? _c(
                                    "v-chip",
                                    {
                                      attrs: {
                                        small: "",
                                        "text-color": "opposite",
                                        color: "warning"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(item.absence_today) +
                                          "\n        "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                    ]
                  }
                },
                {
                  key: "item.specific_status",
                  fn: function({ item }) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(item.specific_status.label) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "item.specific_position",
                  fn: function({ item }) {
                    return [
                      item.roles.length > 1
                        ? _c(
                            "div",
                            _vm._l(item.roles, function(role, index) {
                              return _c("div", { key: index }, [
                                _vm._v(
                                  "\n          " + _vm._s(role) + "\n        "
                                )
                              ])
                            }),
                            0
                          )
                        : _c("div", [
                            _vm._v(
                              "\n        " +
                                _vm._s(item.specific_position.position) +
                                "\n      "
                            )
                          ])
                    ]
                  }
                },
                {
                  key: "item.action",
                  fn: function({ item }) {
                    return [
                      _vm.affectation &&
                      (!_vm.request ||
                        _vm.request.request_status < 5 ||
                        _vm.request.status < 5)
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "align-self-end",
                              attrs: {
                                color: "primary",
                                disabled: _vm.isAssigned(item.id),
                                small: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.handleRowClick(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.isAssigned(item.id)
                                      ? _vm.generateMessage(
                                          "tech_search.assigned"
                                        )
                                      : _vm.generateMessage(
                                          "tech_search.assign"
                                        )
                                  ) +
                                  "\n      "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              226219168
            )
          })
        : _c(
            "loader",
            {
              staticStyle: { height: "64vh" },
              attrs: { "is-loading": _vm.isLoadingMap }
            },
            [
              _c("custom-technician-selector-map", {
                attrs: {
                  affectedTech: _vm.affectedTech,
                  filteredStaff: _vm.filteredItems,
                  request: _vm.request,
                  specialTechnicians: _vm.specialTechnicians,
                  affectation: _vm.affectation,
                  interventions: _vm.interventions
                },
                on: {
                  input: function($event) {
                    return _vm.handleRowClick($event)
                  }
                }
              })
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }